import React from 'react';
import styled from 'styled-components';
import {Typography as Text} from './Typography';
import {AnimateOnViewWrap} from '../../wraps/animation';

const Styled = styled.div``;

export interface AnimatedHeadingProps {
    heading?: string;
    variant?: 'h1' | 'h2' | 'h3' | 'h4';
    big?: true | false;
    as?: 'h1' | 'h2' | 'h3' | 'h4';
}

export const AnimatedHeading = ({
    heading,
    variant = 'h2',
    big = true,
    as
}: AnimatedHeadingProps): JSX.Element | null => {
    if (!heading) return null;
    return (
        <Styled className="ue-heading">
            <AnimateOnViewWrap translateY={50}>
                <Text variant={variant} big={big} as={as}>
                    {heading}
                </Text>
            </AnimateOnViewWrap>
        </Styled>
    );
};
